import { ScrolledMessageObjectType } from "../store/messages/types";

export const EVENT_INSERT_EMOJI = "INSERT_EMOJI";
export const EVENT_RESET_TEXTAREA = "RESET_TEXTAREA";
export const EVENT_REPLACE_TEXTAREA = "REPLACE_TEXTAREA";
export const EVENT_UPDATE_TEXTAREA = "UPDATE_TEXTAREA";
export const EVENT_NEW_SNACKBAR = "NEW_SNACKBAR";
export const EVENT_SCROLL_TO_MESSAGE = "SCROLL_TO_MESSAGE";
export const EVENT_OPEN_MESSAGE_OPTIONS = "OPEN_MESSAGE_OPTIONS";
export const EVENT_OPEN_ROOM_OPTIONS = "OPEN_ROOM_OPTIONS";
export const EVENT_ROOM_MENTION = "ROOM_MENTION";
export const EVENT_INTERNAL_LINK = "INTERNAL_LINK";
export const EVENT_PROFILE_LINK = "PROFILE_LINK";
export const EVENT_INVITE_LINK = "INVITE_LINK";
export const EVENT_INTERNAL_DISCOVERY = "EVENT_INTERNAL_DISCOVERY";
export const EVENT_OPEN_CONTACT_OPTIONS = "OPEN_CONTACT_OPTIONS";
export const EVENT_PASS_PHONE_CHARGE = "EVENT_PASS_PHONE_CHARGE";
export const EVENT_BOT_LINK_BUTTON = "EVENT_BOT_LINK_BUTTON";
export const EVENT_FLOAT_TIME = "EVENT_FLOAT_TIME";
export const EVENT_SW_UPDATE = "EVENT_SW_UPDATE";
export const EVENT_SW_CONFIRM = "EVENT_SW_CONFIRM";

export const METRIX_REGISTER_UNIQUE = "tkuqu"; // وقتی بار اول داره ثبت نام میکنه
export const METRIX_REGISTER_USER = "ncgsr"; // وقتی لاگین کرد با otp
export const METRIX_ACTIVE_CODE = "zjvoh"; // رسپانس otp
export const METRIX_QR_ACTIVATION = "jiqsd"; // رسوانس qr login
export const METRIX_SUBMIT_NO = "jmakn"; // وقتی روی دکمه دریافت otp کلیک میکنه

export type EventScrollToMessagePayloadType = any & { detail: Omit<ScrolledMessageObjectType, "userCalled"> };
export enum DiscoveryEvent {
  openRoom = "EVENT_DISCOVERY_OPEN_ROOM",
  openTile = "EVENT_DISCOVERY_OPEN_TILE",
  toolbar = "EVENT_DISCOVERY_TOOLBAR",
}
